module.exports = {"Home":"首頁","Random Number":"號碼亂數","Random Custom":"自訂隨機亂數","Customization List":"自訂隨機亂數 - 列表","Settings":"設定","About Me":"關於作者","Minimum":"最小值","Maximum":"最大值","Count":"數量","Is Repeat":"是否重複","Automatically Clear The Last Result":"自動清除上次結果","Randomize":"隨機亂數","Clear":"清除","Save":"儲存","Item Name":"項目名字","Delete":"刪除","Are you sure to delete it ?":"確定要刪除嗎 ?","Cancel":"取消","New":"新增","Language":"語言","Theme Color":"主題顏色","English":"英文","Chinese":"中文","Blue":"藍色","Cyan":"青色","Red":"紅色","Pink":"粉紅色","Grey":"灰色","Orange":"橘色","Thank You For Using This. Any Fallback Is Welcome 😊":"謝謝使用, 歡迎任何意見及回饋 😊"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/tw.json
// module id = 443
// module chunks = 1